import { TrackingSummaryApiModel } from '~/lib/api/smartsend/types';

const CalculateLatestTrackingStep = (tracking: TrackingSummaryApiModel): number => {
  let latest: number = 0;
  if (tracking) {
    if (tracking.Collected || tracking.DroppedOff) {
      latest = 1;
    }
    if (tracking.InTransit) {
      latest = 2;
    }
    if (tracking.AtDepot) {
      latest = 3;
    }
    if (tracking.DeliveryScheduled) {
      latest = 4;
    }
    if (tracking.Delivered) {
      latest = 5;
    }
  }
  return latest;
};
export default CalculateLatestTrackingStep;
